// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c57e6de8","453":"fc665ed5","667":"55311561","977":"da3f05e0"}[chunkId] + ".chunk.js";
};